import { render, staticRenderFns } from "./SidebarCard.vue?vue&type=template&id=056f1e26&scoped=true&lang=pug&"
import script from "./SidebarCard.vue?vue&type=script&lang=ts&"
export * from "./SidebarCard.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCard.vue?vue&type=style&index=0&id=056f1e26&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f1e26",
  null
  
)

export default component.exports